import interfacePaperCorrection from './interface-papercorrection'
import interfaceUser from './interface-user'
import interfaceTask from './interface-task'
import interfaceDayi from './interface-dayi'
import interfaceZhaojing from './interface-zhaojing'
// 2021-10-19 潘帅
import interfaceDistribute from './interface-distribute'

let mergeInterface = Object.assign({}, interfacePaperCorrection, interfaceUser, interfaceTask, interfaceDayi, interfaceDistribute, interfaceZhaojing)

export default mergeInterface



// WEBPACK FOOTER //
// ./src/api/interface.js